import React from 'react';

const WhatsAppChatButton = () => {
  const phoneNumber = '+251911248620'; // Replace with your phone number

  return (
    <a
      href={`https://wa.me/${phoneNumber}`}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-chat-button"
    >
      Chat on WhatsApp
    </a>
  );
};

export default WhatsAppChatButton;